<template>
    <md-card class="cta-card" v-on:click.native="learnMore">
        <md-card-header>
            <md-card-header-text class="has-text-left">
                <div class="columns is-variable is-1 is-mobile is-vcentered">
                    <div class="column">
                        <div class="md-title is-size-5 has-text-weight-medium"><md-icon class="has-text-primary">check_circle</md-icon> Get Verified</div>
                        <p class="has-text-grey-dark is-size-7">Get the Verified Badge, Priority Posts, a Trust Score, and an eWallet with a Visa virtual card. Only ₱279 for 3 months.</p>
                    </div>
                    <div class="column is-narrow">
                        <md-icon>arrow_forward</md-icon>
                    </div>
                </div>
            </md-card-header-text>
        </md-card-header>
    </md-card>
</template>

<script>
export default {
    name: "get-verified-prompt",
    props: ['to'],
    methods: {
        learnMore () {
            const vm = this;
            if (vm.$props.to) {
                vm.$router.push({name: 'getVerified', query: { to: vm.$props.to }})
            } else {
                vm.$router.push({name: 'getVerified'})
            }
        }
    }
}
</script>

<style scoped>
    .cta-card {
        -webkit-border-radius: 12px;
        -moz-border-radius: 12px;
        border-radius: 12px;
        margin: 18px 8px;
        box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px, rgba(0, 0, 0, 0.024) 0px -6px 16px -6px;
    }
</style>